module.exports = __webpack_public_path__ + "static/img/Chad-Warner.48b465c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Chad-Warner.jpg
// module id = 2aGX
// module chunks = 0